import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  InputGroup,
  Form,
  // FormFeedback,
} from "reactstrap";
import { updateItemDiscount } from "slices/cart/reducer";

export const DiscountModal = ({ isOpen, toggle, orderItem }) => {
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      discount_type: "Fixed Amount",
      discount_amt: "",
      discount_percentage: "",
    },
    onSubmit: async (values) => {
      const payload = {
        ...orderItem,
        discount_amt:
          values.discount_type === "Fixed Amount" ? values.discount_amt : 0,
        discount_percentage:
          values.discount_type === "Percentage"
            ? values.discount_percentage
            : 0,
      };
      if (payload) {
        console.log("Payload: ", payload);
        dispatch(updateItemDiscount({ id: payload.id, ...payload }));
        formik.resetForm();
        toggle();
      }
    },
  });

  const discountTypes = ["Percentage", "Fixed Amount"];

  useEffect(() => {
    if (orderItem) {
      formik.values.discount_amt = orderItem?.discount_amt;
      formik.values.discount_percentage = orderItem?.discount_percentage;
      formik.values.discount_type =
        orderItem.discount_amt > 0
          ? "Fixed Amount"
          : orderItem.discount_percentage > 0
          ? "Percentage"
          : "";
    }
  }, [orderItem]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Add Discount</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="branchAddress">Discount Type</Label>
            <Input
              id="discount_type"
              name="discount_type"
              value={formik.values.discount_type}
              onChange={formik.handleChange}
              invalid={
                formik.touched.discount_type && !!formik.errors.discount_type
              }
              type="select"
            >
              <option value="" key="0">
                Select Discount type
              </option>
              {discountTypes.map((type, index) => (
                <option value={type} key={type + index}>
                  {type}
                </option>
              ))}
            </Input>
          </FormGroup>
          {formik.values.discount_type === "Fixed Amount" && (
            <FormGroup>
              <Label for="branchName">Discount Amount</Label>
              <InputGroup>
                <span
                  className="input-group-text"
                  style={{ fontSize: "0.85rem" }}
                >
                  GHS
                </span>
                <Input
                  id="discount_amt"
                  name="discount_amt"
                  type="number"
                  min="0"
                  value={formik.values.discount_amt}
                  onChange={formik.handleChange}
                />
              </InputGroup>
            </FormGroup>
          )}
          {formik.values.discount_type === "Percentage" && (
            <FormGroup>
              <Label for="branchName">Discount Percentage</Label>
              <InputGroup>
                <span
                  className="input-group-text"
                  style={{ fontSize: "0.85rem" }}
                >
                  %
                </span>
                <Input
                  id="discount_percentage"
                  name="discount_percentage"
                  type="number"
                  min="0"
                  value={formik.values.discount_percentage}
                  onChange={formik.handleChange}
                  invalid={
                    formik.touched.discount_percentage &&
                    !!formik.errors.discount_percentage
                  }
                />
                {/* {formik.touched.discount_percentage &&
                  formik.errors.discount_percentage && (
                    <FormFeedback>
                      {formik.errors.discount_percentage}
                    </FormFeedback>
                  )} */}
              </InputGroup>
            </FormGroup>
          )}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          type="submit"
          onClick={() => formik.handleSubmit()}
        >
          Add Discount
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};
